module.exports = __webpack_public_path__ + "static/media/rules-step-01.8e68adfb.png";